var map = {
	"./welcome-1.png": "9d29",
	"./welcome-2.png": "657e",
	"./welcome-3.png": "e169",
	"./welcome-4.png": "15e3",
	"./welcome-dashboard-1.png": "2f88",
	"./welcome-dashboard-2.png": "1d21",
	"./welcome-dashboard-3.png": "264e",
	"./welcome-desktop-1.png": "1d76",
	"./welcome-desktop-2.png": "2443",
	"./welcome-kids-mode.png": "9f98",
	"./welcome-loader.png": "d6ad",
	"./welcome-parent-mode-1.png": "a1a4",
	"./welcome-parent-mode-2.png": "4cca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "40a3";